import styled, { createGlobalStyle } from 'styled-components'

export const MoveableHandleStyles = createGlobalStyle`
  .moveable-direction.moveable-nw,
  .moveable-direction.moveable-ne,
  .moveable-direction.moveable-sw,
  .moveable-direction.moveable-se {
    width: 12px !important;
    height: 12px !important;
    margin-top: -6px !important;
    margin-left: -6px !important;
    background-color: white !important;
    border-color: #387DFF !important;
  }

  .moveable-direction.moveable-e,
  .moveable-direction.moveable-w {
    width: 10px !important;
    height: 22px !important;
    margin-top: -11px !important;
    margin-left: -4px !important;
    background-color: white !important;
    border-color: #387DFF !important;
    border-radius:14px !important;
  }

  .moveable-line.moveable-guideline {
    background: #ff3366 !important;
    opacity: 0.7;
  }
`

export const LayerOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 10;
`

export const ItemFrame = styled.div.attrs<{
  $left: number
  $top: number
  $width: number
  $height: number
  $zIndex: number
  $rotation: number
  $flipX: boolean
  $isActive: boolean
  $isMovableVisible: boolean
  $isSelectionChromeVisible: boolean
}>(({ $left, $top, $width, $height, $zIndex, $rotation, $flipX }) => ({
  style: {
    left: `${$left}px`,
    top: `${$top}px`,
    width: `${$width}px`,
    height: `${$height}px`,
    zIndex: $zIndex,
    transform: `rotate(${$rotation}deg) scaleX(${$flipX ? -1 : 1})`
  }
}))`
  position: absolute;
  /* iOS Safari intercepts double-tap as a zoom gesture by default, so
     dblclick never reaches React's onDoubleClick and the user can't enter
     text edit mode. 'manipulation' tells Safari we handle the gesture —
     no double-tap zoom, no 300ms ghost-click delay, dblclick fires. */
  touch-action: manipulation;
  cursor: ${({ $isActive, $isMovableVisible, $isSelectionChromeVisible }) =>
    !$isMovableVisible
      ? 'default'
      : $isActive && $isSelectionChromeVisible
        ? 'move'
        : 'pointer'};
  outline: ${({ $isSelectionChromeVisible }) =>
    $isSelectionChromeVisible ? '2px solid #387DFF' : '2px solid transparent'};
  &:hover {
    outline-color: ${({ $isMovableVisible }) =>
      $isMovableVisible ? '#387dff' : 'transparent'};
  }
`
